module.exports = __webpack_public_path__ + "static/media/praxisraum.675e4eb7.jpg";